;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { isSonnerToastInteractionTarget } from "@/components/ui/sonner-toast-interaction";
import { isTourJoyrideInteractionTarget } from "@/features/onboarding-tours/lib/is-tour-joyride-interaction-target";

type OutsideDismissEvent = {
	defaultPrevented: boolean;
	preventDefault: () => void;
};

/** Sonner and Joyride render outside modal hosts; Radix would otherwise dismiss or steal focus. */
export function preventAuxiliaryOutsideDismiss({
	event,
	target,
}: {
	event: OutsideDismissEvent;
	target: EventTarget | null;
}) {
	if (event.defaultPrevented) {
		return;
	}

	if (
		isSonnerToastInteractionTarget(target) ||
		isTourJoyrideInteractionTarget(target)
	) {
		event.preventDefault();
	}
}
